import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';
import { useInView } from 'react-intersection-observer';

const Flex = ({ children, classes }) => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <motion.div
      className={`flex ${classes}`}
      ref={ref}
      initial={{ opacity: 0.3, scale: 0.95 }} // 👈 Smoother initial state
      animate={
        inView ? { opacity: 1, scale: 1 } : { opacity: 0.3, scale: 0.95 }
      }
      transition={{ duration: 0.5, ease: 'easeOut' }} // 👈 More natural easing
    >
      {children}
    </motion.div>
  );
};

Flex.defaultProps = {
  classes: '',
};

Flex.propTypes = {
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export { Flex };
